import { Country } from '../country';
export class City {
    constructor(
        public id?: number,
        public name?: string,
        public abbrev?: string,
        public country?: Country,
    ) {
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/city/city.model.ts